import { createContext, FC, useContext, useEffect, useState, ReactNode } from 'react';
import axios from 'axios';

const AuthContext = createContext<
  | {
    user: any
  }
  | undefined
>(undefined);

const AuthProvider: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    axios({
      method: 'POST',
      withCredentials: true,
      url: `${process.env.REACT_APP_CDM_API}/api/auth/me`
    }
    ).then((res) => {
      setUser(res.data)
      setLoading(false)

    }).catch(() => {
      const url = `${process.env.REACT_APP_CDM_API}/auth/login?returnTo=${window.location}`
      window.location.replace(url)
    })
  }, [])


  if (loading) {
    return <h1>Loading...</h1>
  }


  return (
    <AuthContext.Provider
      value={{
        user
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  return context;
};

export { useAuth };
export default AuthProvider;
